import { useTranslation } from 'react-i18next';

// Import helpers
import { getConfirmedAgreementVersions } from 'components/views/offer_configurator/helpers/agreements';

// Import utilities
import { openNotification } from 'components/utilities/notification/notification';

// Import query
import { useGetSubscriberAgreementsQuery, useUpdateSubscriberAgreementsMutation } from 'store/features/subscriberAgreements';

export const useUserAgreements = (type: string[]) => {
	const { t } = useTranslation('configurator');
	const { data = [], isFetching } = useGetSubscriberAgreementsQuery();
	const [updateUserAgreements, { isLoading }] = useUpdateSubscriberAgreementsMutation();

	const confirmedAgreements = getConfirmedAgreementVersions(data, type);

	const handleAgreementChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		const value = +e.target.value;

		const requestType = !confirmedAgreements.includes(value) ? 'accept' : 'decline';

		updateUserAgreements({ agreement_version_ids: [value], type: requestType })
			.unwrap()
			.then(() => {
				openNotification({
					type: 'success',
					title: t('notification_success_title'),
					description: t('notification_success_desc_agreements'),
					duration: 4
				});
			})
			.catch(() => {
				openNotification({
					type: 'error',
					title: t('notification_error_title'),
					description: t('notification_error_desc_agreements'),
					duration: 4
				});
			});
	};

	return {
		isLoading: isFetching || isLoading,
		confirmedAgreements,
		handleAgreementChange
	};
};
